    var $ = window.jQuery

    $(function() {
      // 导航栏颜色
      $('#header ul li:eq(1) a').attr('class','activity');
      // 二维码显示隐藏
      $(".scan").hover(function() {
				$(".download img").css({
					'display': 'block',
				})
			},function() {
				$(".download img").css({
					'display': 'none',
				})
			})

      // 获取安卓APP统计量
      function loadUserAppDownloadStatics() {
        $.ajax({
          url:'http://www.sq580.com/v3/application',
          type:'post',
          dataType:'json',
          data:{
            type:'user'
          },
          success:function(result) {
            if (!result.err) {
    					if (result.data && result.data > 0) {
                $('.download-count').show();
                $('.download-count span').html(commafy(result.data))
    					}
  				  }
          },
          error:function() {
            console.log("下载量加载错误！");
          }
        })
      }

      // 统计下载量数量显示 格式
      function commafy(num){
        num = parseInt(num) + 1000000
        if((num+"").trim()==""){
         return"";
        }
        if(isNaN(num)){
         return"";
        }
        num = num+"";
        if(/^.*\..*$/.test(num)){
         varpointIndex =num.lastIndexOf(".");
         varintPart = num.substring(0,pointIndex);
         varpointPart =num.substring(pointIndex+1,num.length);
         intPart = intPart +"";
          var re =/(-?\d+)(\d{3})/
          while(re.test(intPart)){
           intPart =intPart.replace(re,"$1,$2")
          }
         num = intPart+"."+pointPart;
        }else{
         num = num +"";
          var re =/(-?\d+)(\d{3})/
          while(re.test(num)){
           num =num.replace(re,"$1,$2")
          }
        }
        return num;
      }
      loadUserAppDownloadStatics();

      // 居民端下载iOS端统计
      $('.download-user-ios').click(function(){
          statistics('loaduser_selfpc_ios','居民自行下载');
      });

      // 居民端下载安卓端统计
      $('.download-android').click(function(){
        statistics('loaduser_selfpc_android','居民自行下载')
    		$.ajax({
    			url : 'http://www.sq580.com/v3/application/add',
    			type : 'POST',
    			data: {
    				type: 'user'
    			},
    			contentType:"application/x-www-form-urlencoded; charset=UTF-8",
    			beforeSend: function(){},
    			success : function(result) {
    				if (!result.err) {
    					loadUserAppDownloadStatics()
    				}
    			},
    			error:function(XMLHttpRequest, textStatus, errorThrown){}
    		})
      });

    })
